module.exports = __webpack_public_path__ + "img/hat1.b17a422d.png";